import React, { useState, useEffect } from "react";
import { Row, Col, Input, Divider, Button, Tooltip, Card } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { labelDateSelector } from "../../../../store/var/var.selector";
import { detailBranchSelector } from "../../../../store/branch/branch.selector";
import {
  CloseOutlined,
  PlusCircleFilled,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { formatNumber } from "../../../../store/utils/format_number/format_number";
import lodash from "lodash";
import DialogDiscountAdd from "../../dialog/dialog_discount_add";
import {
  snapAllDiscount,
  unSnapDiscount,
} from "../../../../store/discount/discount.action";
import CashupDiscountList from "../../dialog/dialog_cashup_discount_list";

const CashupDiscount = ({ edit }) => {
  // -------------------------- STATE --------------------------
  const [open, setOpen] = useState(false);
  const [openList, setOpenList] = useState(false);
  const [jobDiscount, setJobDiscount] = useState([]);
  const [data, setData] = useState([]);
  // -------------------------- FUNCTION --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const label = useSelector(labelDateSelector);
  const branch = useSelector(detailBranchSelector);

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (label && branch) {
      dispatch(
        snapAllDiscount({ date: label, branch: branch?.id }, (res) => {
          if (res) {
            const data = res?.notes || [];
            const jobDiscount = res?.jobs || [];
            setData(data);
            setJobDiscount(jobDiscount); // set jobDiscount
          } else {
            setData([]);
            setJobDiscount([]); // reset jobDiscount
          }
        })
      );
    }

    return () => dispatch(unSnapDiscount());
  }, [dispatch, label, branch]);
  // -------------------------- RENDER --------------------------
  const renderList = () => {
    return (
      <Row style={{ width: "100%" }}>
        {data?.map((item, index) => {
          const note = item?.note;
          const value = item?.value;
          const labelValue = formatNumber(value);

          return (
            <Row key={index} style={{ width: "100%", margin: "6px 0px" }}>
              <Col span={14}>{note}</Col>
              <Col align="right" span={10}>
                ${labelValue}
              </Col>
            </Row>
          );
        })}
      </Row>
    );
  };

  const renderAddIcon = () => {
    return (
      <Tooltip title="Add Discount">
        <Button
          type="text"
          shape="circle"
          onClick={() => setOpen(true)}
          disabled={!edit}
          icon={
            <span className="anticon">
              <PlusCircleFilled
                style={{ fontSize: 24, color: edit ? "green" : "gray" }}
              />
            </span>
          }
        />
      </Tooltip>
    );
  };

  const renderTotal = () => {
    const totatData = [...data, ...jobDiscount];
    const finalValue = lodash?.sumBy(totatData, (d) => d?.value);
    const labelFinal = formatNumber(finalValue);
    return labelFinal;
  };

  const renderDiscountFromJob = () => {
    const discountTotal = lodash?.sumBy(jobDiscount, (d) => d?.value);
    const labelValue = formatNumber(discountTotal);
    return (
      <Row style={{ width: "100%", margin: "6px 0px" }} align="middle">
        <Col span={14}>{renderLabel()}</Col>
        <Col align="right" span={10}>
          ${labelValue}
        </Col>
      </Row>
    );
  };

  const renderLabel = () => {
    const text = "Total discount from job:";
    return (
      <Row gutter={[10, 10]} align="middle">
        <Col>{text}</Col>
        <Col>
          <Tooltip title="View discount from job details">
            <Button
              type="primary"
              size="small"
              icon={<UnorderedListOutlined />}
              onClick={() => setOpenList(true)}
            />
          </Tooltip>
        </Col>
      </Row>
    );
  };
  // -------------------------- MAIN --------------------------
  const title = (
    <Row style={{ width: "100%" }}>
      <Col span={14}>Discount / Cash withdrawal: </Col>
      <Col align="right" span={10}>
        ${renderTotal()}
      </Col>
    </Row>
  );
  return (
    <Row span={24} style={{ width: "100%" }}>
      <Col span={24}>
        <Card className="item-card" title={title}>
          <Col span={24}>{renderDiscountFromJob()}</Col>
          <Col span={24}>{renderList()}</Col>
          <Col span={24}>{renderAddIcon()}</Col>
          <DialogDiscountAdd open={open} setOpen={setOpen} />
        </Card>
      </Col>
      <CashupDiscountList
        open={openList}
        setOpen={setOpenList}
        data={jobDiscount}
      />
    </Row>
  );
};

export default CashupDiscount;
